import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from '@config/firebase';
import { cacheManager, CACHE_KEYS, CACHE_TTL } from './cacheManager';

/**
 * Get avatar URL from Firebase Storage with proper authentication
 * @param uid - User ID
 * @returns Promise<string> Avatar URL for the user
 */
export const getAvatarUrlAsync = async (uid: string): Promise<string> => {
  try {
    const cacheKey = `${CACHE_KEYS.AVATAR_URL}_${uid}`;
    const cachedUrl = cacheManager.get<string | null>(cacheKey);

    if (cachedUrl !== null) {
      if (cachedUrl === '') {
        return '';
      }
      return cachedUrl;
    }

    const avatarRef = ref(storage, `images/${uid}.jpg`);
    const downloadURL = await getDownloadURL(avatarRef);

    cacheManager.set(cacheKey, downloadURL, CACHE_TTL.LONG);

    return downloadURL;
  } catch (error: any) {
    if (error?.code === 'storage/object-not-found') {
      const cacheKey = `${CACHE_KEYS.AVATAR_URL}_${uid}`;
      cacheManager.set(cacheKey, '', CACHE_TTL.LONG);
      return '';
    }
    console.warn(`[AVATAR ERROR] ${uid.substring(0, 8)}`, error);
    return '';
  }
};

export const invalidateAvatarCache = (uid: string): void => {
  const cacheKey = `${CACHE_KEYS.AVATAR_URL}_${uid}`;
  cacheManager.clear(cacheKey);
};